import { Form } from 'antd';
import React, { memo } from 'react';
import CollapsibleCard from 'components/CollapsibleCard';
import LineItemTabs from 'components/LineItemTabs';
import { HtsValuesContextProvider } from 'context/htsValues';
import { useArrivalDate } from 'libs/hooks';
import { CommercialInvoiceBaseProps } from 'types';

export interface LineItemV2Props extends CommercialInvoiceBaseProps {
  index?: number;
  keyRef: React.MutableRefObject<string>;
}

/**
 * LineItemV2
 *
 * Line-level information for a commercial invoice product. Can appear in the Product drawer
 * or inline for single product view.
 */

export const LineItemV2: React.FC<LineItemV2Props> = ({
  index = 0,
  fullNamePath,
  localNamePath,
  workOrderType,
  keyRef,
  readOnly,
  disabled,
  required,
  isInboundBooking,
}) => {
  const form = Form.useFormInstance();
  const arrivalDate = useArrivalDate();
  const tariffs = Form.useWatch([...fullNamePath, 'tariffs'], form) ?? [{}];
  const htsNumbers = tariffs
    .filter((tariff: { htsNumber?: string }) => tariff?.htsNumber)
    .map((tariff: { htsNumber: string }) => tariff.htsNumber);
  return (
    <HtsValuesContextProvider htsNumbers={htsNumbers} arrivalDate={arrivalDate}>
      <CollapsibleCard
        title={`Line ${index + 1}`}
        defaultExpanded={index === 0}
      >
        <LineItemTabs
          fullNamePath={fullNamePath}
          localNamePath={localNamePath}
          workOrderType={workOrderType}
          keyRef={keyRef}
          tariffs={tariffs}
          readOnly={readOnly}
          disabled={disabled}
          required={required}
          isInboundBooking={isInboundBooking}
        />
      </CollapsibleCard>
    </HtsValuesContextProvider>
  );
};

export default memo(LineItemV2);
